"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reservationInvoiceColumns = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const dateTimeFormat_1 = require("../../../utils/dateTimeFormat");
const idColumn_1 = require("../../Table/columns/idColumn");
const Tooltip_1 = require("../../Tooltip");
const WeekDay_1 = require("../../WeekDay");
const FlightPassengersCell_1 = require("../List/components/FlightPassengersCell");
const ReservationPhoneCell_1 = require("../List/components/ReservationPhoneCell");
const ReservatorCell_1 = require("../List/components/ReservatorCell");
const Payment_1 = require("../List/Payment");
const actionsColumn_1 = require("./actionsColumn");
require("./tableColumns.scss");
const reservationInvoiceColumns = (config) => {
    var _a, _b, _c, _d, _e, _f;
    return [
        (0, idColumn_1.idColumn)({
            hidden: (_a = config.id) === null || _a === void 0 ? void 0 : _a.hidden,
        }),
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnOwner', defaultMessage: 'Owner' })),
            Cell: ({ row }) => {
                const { owner } = row.original;
                if (!owner)
                    return null;
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(ReservatorCell_1.ReservatorCell, { value: owner }),
                    react_1.default.createElement(ReservationPhoneCell_1.ReservationPhoneCell, { value: owner })));
            },
            id: 'customer',
            disableSortBy: true,
            hidden: (_b = config.owner) === null || _b === void 0 ? void 0 : _b.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnOutbound', defaultMessage: 'Outbound' })),
            id: 'flightOutbound',
            canSort: true,
            Cell: ({ row }) => (react_1.default.createElement(FlightPassengersCell_1.FlightPassengersCell, { reservation: row.original, flight: row.original.flights.outbound })),
            hidden: (_c = config.outbound) === null || _c === void 0 ? void 0 : _c.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnReturn', defaultMessage: 'Return' })),
            id: 'flightReturn',
            canSort: true,
            Cell: ({ row }) => (react_1.default.createElement(FlightPassengersCell_1.FlightPassengersCell, { reservation: row.original, flight: row.original.flights.return })),
            hidden: (_d = config.return) === null || _d === void 0 ? void 0 : _d.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnPayment', defaultMessage: 'Payment' })),
            id: 'payment',
            Cell: ({ row }) => {
                var _a, _b, _c;
                return (react_1.default.createElement(Payment_1.ListPaymentCell, { total: (_a = row.original.invoice) === null || _a === void 0 ? void 0 : _a.total, totalPaid: (_b = row.original.invoice) === null || _b === void 0 ? void 0 : _b.totalPaid, payments: (_c = row.original.invoice) === null || _c === void 0 ? void 0 : _c.payments }));
            },
            disableSortBy: true,
            hidden: (_e = config.payment) === null || _e === void 0 ? void 0 : _e.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnPaymentDeadline', defaultMessage: 'Payment Deadline' })),
            id: 'paymentDeadline',
            canSort: true,
            Cell: ({ row }) => {
                const invoice = row.original.invoice;
                if (!invoice.paymentDeadline) {
                    return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List/InvoiceOverview/PaymentDeadline:deadlineNotSet', defaultMessage: 'Deadline not set' }));
                }
                const datetime = (0, moment_1.default)(invoice.paymentDeadline);
                const content = (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(WeekDay_1.WeekDay, { name: datetime, modificators: 'margin-right' }),
                    react_1.default.createElement("span", null, datetime.format(dateTimeFormat_1.DATE_FORMAT)),
                    react_1.default.createElement("div", null, datetime.format(dateTimeFormat_1.TIME_FORMAT))));
                const expired = ((invoice.status === 'partly' || invoice.status === 'unpaid')
                    && ((0, moment_1.default)().valueOf() > datetime.valueOf()));
                if (!expired)
                    return content;
                const className = 'deadline-datetime';
                const classNames = (0, classFunctions_1.getClasses)(className, [
                    expired ? 'color-red' : undefined,
                ]);
                return (react_1.default.createElement("div", { className: classNames.join(' ') },
                    react_1.default.createElement(Tooltip_1.Tooltip, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List/InvoiceOverview/PaymentDeadline:deadlineIsOver', defaultMessage: 'Deadline is over' }), modificators: 'white' }, content)));
            },
            hidden: (_f = config.paymentDeadline) === null || _f === void 0 ? void 0 : _f.hidden,
        },
        (0, actionsColumn_1.reservationInvoiceActionsColumn)(config.actions),
    ];
};
exports.reservationInvoiceColumns = reservationInvoiceColumns;
//# sourceMappingURL=tableColumns.js.map